import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	align-items: center;
	justify-content: center;
`;

export const boxEditor = styled.div`
	width: 100%;
	background-color: ${color.interface.white};
`;

export const title = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 0.5rem;
	> p {
		font-weight: 700;
		color: ${color.interface.lightGray};
		font-size: 1.4rem;
	}
`;
